
import React from 'react';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { Badge } from '@/components/ui/badge';
import { type Gift } from '@/utils/types';
import TransactionItem from './TransactionItem';

interface TransactionListProps {
  gifts: Gift[];
  selectedGifts: Gift[];
  onSelectGift: (gift: Gift) => void;
  onSelectAll: () => void;
}

const TransactionList: React.FC<TransactionListProps> = ({ 
  gifts, 
  selectedGifts, 
  onSelectGift, 
  onSelectAll 
}) => {
  const totalSelectedAmount = selectedGifts.reduce((sum, gift) => sum + gift.amount, 0);
  
  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center gap-2">
          <Checkbox 
            id="select-all" 
            checked={selectedGifts.length === gifts.length && gifts.length > 0}
            onCheckedChange={onSelectAll}
          />
          <Label htmlFor="select-all" className="cursor-pointer">
            Select All ({gifts.length})
          </Label>
        </div>
        
        {selectedGifts.length > 0 && (
          <Badge variant="outline" className="bg-givgo-light text-givgo-purple">
            ${totalSelectedAmount} selected
          </Badge>
        )}
      </div>
      
      <ScrollArea className="h-[300px] pr-4">
        <div className="space-y-3">
          {gifts.map(gift => (
            <TransactionItem 
              key={gift.id}
              gift={gift}
              isSelected={selectedGifts.some(g => g.id === gift.id)}
              onSelect={onSelectGift}
            />
          ))}
          
          {gifts.length === 0 && (
            <div className="text-center py-10 text-muted-foreground">
              No transactions available for this brand
            </div>
          )}
        </div>
      </ScrollArea>
    </div>
  );
};

export default TransactionList;
